export default __webpack_public_path__ + "static/platform_support-7484d94aa9ac991f8712cbf73b56d95c.webp";